/**
 * API Service for ActivityMapping
 */

import { makeCygnusApiCall } from "api/api";

/**
 * Fetches all the pbc client documents for the particular clientmasterid.
 * @param {object} payload - The ID of the client to fetch data for.
 */
export const getInternalK1ActivitiesData = async (payload: any): Promise<any> => {
  const activitiesData = await makeCygnusApiCall({
    type: "POST",
    payload: payload,
    url: `/documents/internalk1/activities/`,
    show_message: false,
    customized_success_message: "Fetched Internal K1 Activities Data Successfully",
    customized_failure_message: "Unable to fetch Internal K1 Activities data, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true
  })

  return activitiesData?.data ?? [];
}

/**
 * Updates the internal k1 activities cache in db
 * @param {object} payload - activities data
 */
export const saveInternalK1ActivitiesMappings = async (payload: any): Promise<any> => {
  const response = await makeCygnusApiCall({
    type: "POST",
    payload: payload,
    url: `/documents/internalk1/update_activities/`,
    show_message: true,
    customized_success_message: "Activity Mapping Saved",
    customized_failure_message: "Unable to Update Internal K1 Activities Data to tax, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true
  })
  return response ?? false;
}
